
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-in/ally",
      function () {
        return require("private-next-pages/sign-in/ally.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign-in/ally"])
      });
    }
  